/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchPccDemographicsResponse
 */
export interface PatchPccDemographicsResponse {
    /**
     * 
     */
    success?: boolean;
    /**
     * 
     */
    demographic_warnings?: Array<string>;
}

/**
 * Check if a given object implements the PatchPccDemographicsResponse interface.
 */
export function instanceOfPatchPccDemographicsResponse(value: object): value is PatchPccDemographicsResponse {
    return true;
}

export function PatchPccDemographicsResponseFromJSON(json: any): PatchPccDemographicsResponse {
    return PatchPccDemographicsResponseFromJSONTyped(json, false);
}

export function PatchPccDemographicsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchPccDemographicsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'demographic_warnings': json['demographic_warnings'] == null ? undefined : json['demographic_warnings'],
    };
}

export function PatchPccDemographicsResponseToJSON(json: any): PatchPccDemographicsResponse {
    return PatchPccDemographicsResponseToJSONTyped(json, false);
}

export function PatchPccDemographicsResponseToJSONTyped(value?: PatchPccDemographicsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'demographic_warnings': value['demographic_warnings'],
    };
}

